// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { object } from 'prop-types'
import protection_metrics_tower from 'images/protection-metrics-tower.png'
import CaptionItem from './CaptionItem'

import {
  CaptionHeading,
  CaptionImage,
} from './styles'

const Caption = ({ metrics }) => (
  <div className={'display-flex align-items-center'}>
    <div className={'display-flex'}>
      <CaptionHeading>
        <strong>{'Comsearch Protection Overview'}</strong>
        <span>{`${metrics.banner_group} MONTH`}</span>
      </CaptionHeading>
      <CaptionImage
        alt={'Protection Metrics Tower'}
        src={protection_metrics_tower}
        title={'Protection Metrics Tower'} />
    </div>
    <div className={'display-flex justify-content-around flex-wrap-wrap flex-1'}>
      <CaptionItem count={metrics.pcn_count}>
        {'PCNs'}<br/>{'received'}
      </CaptionItem>
      <CaptionItem count={metrics.path_count}>
        {'microwave paths'}<br/>{'analyzed'}
      </CaptionItem>
      <CaptionItem count={metrics.non_interference_cases}>
        {'cases'}<br/>{'analyzed'}
      </CaptionItem>
      <CaptionItem count={metrics.total_cases}>
        {'cases reported for'}<br/>{'coordination resolution'}
      </CaptionItem>
    </div>
  </div>
)

Caption.propTypes = {
  metrics: object.isRequired,
}

export default Caption
